import FindPlace from './FindPlace';

export default FindPlace;
